import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit, AiOutlineDelete, AiOutlineFileExcel } from 'react-icons/ai';
import toast from 'react-hot-toast';
import axios from 'axios';
import fileDownload from "js-file-download";
import { GetSearchService } from '../../services/AuthServices'
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeleteClientService, DownloadClientService, GetReTargetClientAnalyticsService } from '../../services/ClientServices';
import { CgRadioCheck,CgRadioChecked } from "react-icons/cg";
import DashboardMenu from './DashboardMenu';
import { useSearchParams } from 'react-router-dom';
import { MdOutlineCallToAction } from "react-icons/md";
import { MdCheckBoxOutlineBlank,MdCheckBox } from "react-icons/md";
import { SendClientTemplateMessageMassService } from '../../services/ClientChatServices';
import { TextInput } from '../../components/input';
import { CreateVoiceCallListService } from '../../services/admin/VoiceCallListServices';
import ErrorComponent from '../../components/ErrorComponent';
import dayjs from "dayjs";
import { GetFileStandardService } from '../../services/admin/FileStandardServices';
import { GetAllTemplateService } from '../../services/TemplateServices';
import { GetCityListService } from '../../services/admin/CityListServices';

function ReTargetClients() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)

  const [searchParams] = useSearchParams();
  const search_type = searchParams.get('type'); 

  const subscribedStatus = [{label:'Subscribed',value:'1'},{label:'Not Subscribed',value:'2'},]
  const sourceSystem = [{label:'App',value:'app'},{label:'Wati',value:'wati'},{label:'Meta',value:'meta'},]
  const subscribedStatusSystem = ['Subscribed','App Installed','App Not Installed']

  console.log("search_type -->",search_type)
  const [selectedSourceSystem, setselectedSourceSystem] = useState("app")
  const [selectedsubscribedStatusSystem, setselectedsubscribedStatusSystem] = useState("Subscribed")

  const [modal, setmodal] = useState(false)
  const [callModal, setcallModal] = useState(false)
  const [messageModal, setmessageModal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})

  const [users,setusers] = useState([])
  const [filterOption,setfilterOption] = useState([])

  const [search, setsearch] = useState({ text: '', text1:'', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,user:'',subscribed_status:'',template_message:''})
  
  const [voiceCall,setvoiceCall] = useState({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
  const [voiceCallErr,setvoiceCallErr] = useState({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})

  const [massMessage,setmassMessage] = useState({name:''})
  const [massMessageErr,setmassMessageErr] = useState({name:''})


  const [selecteddataList, setselecteddataList] = useState([])

  const templateMessage = [{label:'Final Message',value:'finalning'},{label:'Welcome Message',value:'welcomemsg11'},]

  
  const [templateMessageArr, settemplateMessageArr] = useState([])

  const [cityOptions, setcityOptions] = useState([])
  const [city, setcity] = useState('')

  useEffect(()=>{
    getFilterfunc()
    getTemplateMessage()
  },[])

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  async function getTemplateMessage(){
    const response = await GetAllTemplateService()
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr?.push({label:d?.name,value:d?._id})
    })
    settemplateMessageArr(arr)
  }

  console.log("templateMessageArr",templateMessageArr)

  useEffect(() => {
    getdata()
  }, [selectedSourceSystem, selectedsubscribedStatusSystem, page, city])


  async function getFilterfunc() {
    const response = await GetFileStandardService()
    let arr = []
    response?.data?.datas?.filter((d)=>{
      arr.push({label:d?.standard,value:d?._id,data:d})
    })
    setfilterOption(arr)
  }

  // console.log("filterOption",filterOption)

  async function getdata() {
    const response = await GetReTargetClientAnalyticsService(page, search?.text ? search?.text?.data?.match_string : '', search?.from_date1, search?.to_date1, search?.user, selectedSourceSystem,selectedsubscribedStatusSystem,search?.text1,city || '')
    // const response = await GetReTargetClientAnalyticsService(page, search?.text, search?.from_date1, search?.to_date1, search?.user, selectedSourceSystem,selectedsubscribedStatusSystem)
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetReTargetClientAnalyticsService(page, search?.text ? search?.text?.data?.match_string : '', search?.from_date1, search?.to_date1, search?.user, selectedSourceSystem,selectedsubscribedStatusSystem,search?.text1,city || '')
    // const response = await GetReTargetClientAnalyticsService(page, search?.text, search?.from_date1, search?.to_date1, search?.user, selectedSourceSystem,selectedsubscribedStatusSystem)
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', text1:'', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false, user: '',subscribed_status:'',template_message:'' })
    setcity('')
    setpage(1)
    const response = await GetReTargetClientAnalyticsService(1, '', '', '', '',selectedSourceSystem,selectedsubscribedStatusSystem,'','')
    setdata(response?.data)
  }

  async function deleteData() {
    const response = await DeleteClientService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

  async function downloaddata() {
    const response = await DownloadClientService(1, search?.text, search?.from_date1, search?.to_date1, '')
    let path = response.data.path.replace('public/', '')
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`
    window.open(url,'_blank')
    // handleDownload(`${process.env.REACT_APP_BACKEND_IMAGE_URL}${path}`, path.split('/')[path.split('/')?.length - 1])
  }

   async function searchemployee(e){
    const response = await GetSearchService(e,1)
    let arr = []
    response?.data?.datas?.forEach((d)=>{
      arr.push({label:d?.name,value:d?._id})
    })
    setusers(arr)
  }

  const handleDownload = (url, filename) => {
    axios.get(url, {
      responseType: 'blob',
    })
      .then((res) => {
        fileDownload(res.data, filename)
      })
  }


  function openFile(v){
    let url = `${process.env.REACT_APP_BACKEND_IMAGE_URL}${v}`
    window.open(url,'_blank')
  }

  function selectdatas(v){
    if(selecteddataList?.includes(v)){
      setselecteddataList(selecteddataList.filter(f=>f!==v))
    }else{
      if(selecteddataList.length < 150){
        setselecteddataList([...selecteddataList,v])
      }else{
        toast.error("Maximum Selected Reached : 150")
      }
    }
  }


  function selectOption(v) {
  if (v === '3') {
    setselecteddataList([]);
  }

  // if (v === '1') {
    // const allIds = data?.datas?.map(d => d?._id) || [];
    // const oldData = [...selecteddataList, ...allIds];
    // const uniqueData = Array.from(new Set(oldData));
    // setselecteddataList(uniqueData);
  // }

  if (v === '1') {
    const allIds = data?.datas?.map(d => d?._id) || [];
    const oldData = [...selecteddataList, ...allIds];
    const uniqueData = Array.from(new Set(oldData)).slice(0, 150);
    setselecteddataList(uniqueData);
  }

  if (v === '2') {
    const currentData = data?.datas?.map(d => d?._id) || [];
    const updatedData = selecteddataList.filter(id => !currentData.includes(id));
    setselecteddataList(updatedData);
  }
}

  async function sendTemplateMessage(){
    if(selecteddataList?.length === 0){
      toast.error("Selected Data List should not be empty")
    }else if(!massMessage?.name){
      toast.error("Campaign Name is required")
    }else if(!search?.template_message){
      toast.error("Template Message should be selected")
    }else{
      let sendData = {
        customer:selecteddataList,
        name:massMessage?.name,
        template:search?.template_message
      }
      const response = await SendClientTemplateMessageMassService(sendData)
      if(response){
        setselecteddataList([])
        setmassMessage({name:''})
        setmassMessageErr({name:''})
        toast.success("Client Template Message Shared!", { duration: 5000 })
        setmessageModal(false)
      }else{
      }
    }
  }

  function handlechange(e){
    let {name,value} = e.target
    setvoiceCall({...voiceCall,[name]:value})
    setvoiceCallErr({...voiceCallErr,[name]:''})
  }

  function handlechange1(e){
    let {name,value} = e.target
    setmassMessage({...massMessage,[name]:value})
    setmassMessageErr({...massMessageErr,[name]:''})
  }


  async function submitCall(){
    let send_data = {...voiceCall}
    send_data['targeted_customer'] = selecteddataList?.map((s)=>({customer:s,status:'PENDING'}))
    await CreateVoiceCallListService(send_data)
    toast.success("Voice Call Created Successfully!")
    setvoiceCall({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
    setvoiceCallErr({campaign_type:'',scheduled_at:'',scheduled_at_1:'',cli_number:'',campaign_name:'',voice_file_id:''})
    setcallModal(false)
    setselecteddataList([])
  }

  const validateSchedule = (date) => {
      const selected = dayjs(date);
      const now = dayjs();

      if (selected.isBefore(now)) {
        return "You cannot select a past date or time.";
      }

      const hour = selected.hour();

      if (hour < 7 || hour > 19) {
        return "Time must be between 7:00 AM and 7:00 PM.";
      }

      return ""; 
  };


  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        keepMounted
        open={callModal}
        onClose={() => setcallModal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] mb-2 w-full">Create VoiceCall</h6>
          <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Be sure while creating the voice call once created will not be deelted in track</h6>
          
          <TextInput 
            label={'Campaign Type'}  
            variant="standard"
            name="campaign_type"
            type="text"
            error={voiceCallErr.campaign_type}
            value={voiceCall.campaign_type}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <h6 className='text-[11px] font-[400] my-1'>Scheduled At</h6>
            <DatePicker 
            className='border border-slate-300 rounded-[0px] w-full'
            showTime={{ format: 'HH:mm:ss' }}
            format="YYYY-MM-DD HH:mm:ss"
            label={'Scheduled At'}  
            variant="standard"
            name="scheduled_at"
            error={voiceCallErr.scheduled_at}
            value={voiceCall.scheduled_at_1}
            onChange={(e,e1)=>{
              const error = validateSchedule(e);
              if (error) {
                  setvoiceCallErr({ ...voiceCallErr, scheduled_at: error });
                  setvoiceCall({ ...voiceCall, scheduled_at: "", scheduled_at_1: null });
                  return;
              }
              setvoiceCall({...voiceCall,scheduled_at:e1,scheduled_at_1:e});
              setvoiceCallErr({...voiceCallErr,scheduled_at:'',scheduled_at_1:''})
            }}
            placeholder=""
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <ErrorComponent error={voiceCallErr.scheduled_at} />

            


            <TextInput 
            label={'Cli Number'}  
            variant="standard"
            name="cli_number"
            type="text"
            error={voiceCallErr.cli_number}
            value={voiceCall.cli_number}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>


            <TextInput 
            label={'Campaign Name'}  
            variant="standard"
            name="campaign_name"
            type="text"
            error={voiceCallErr.campaign_name}
            value={voiceCall.campaign_name}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <TextInput 
            label={'Voice File Id'}  
            variant="standard"
            name="voice_file_id"
            type="text"
            error={voiceCallErr.voice_file_id}
            value={voiceCall.voice_file_id}
            handlechange={handlechange}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

         
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setcallModal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Save'} onClick={() => submitCall()} />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        keepMounted
        open={messageModal}
        onClose={() => setmessageModal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] mb-2 w-full">Create Mass Template Message</h6>
          <h6 className='bg-slate-100 text-[12px] p-1.5 font-[400]'>Be sure while creating the voice call once created will not be delted in track</h6>
          
          <TextInput 
            label={'Campaign Name'}  
            variant="standard"
            name="name"
            type="text"
            error={massMessageErr.name}
            value={massMessage.name}
            handlechange={handlechange1}
            placeholder="Enter your days"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

            <div >
              {/* <input id="search_text" placeholder='Add Template' type='text' value={search.template_message} onChange={(e) => setsearch({ ...search, template_message: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' /> */}
                <div >
                <h6 className='text-[11px] mt-1 mb-[4px]'>Select Template</h6>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.template_message == '' ? null : search?.template_message}
                  bordered={false}
                  // onSearch={searchemployee}
                  className='border h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={templateMessageArr}
                  onChange={(e)=>setsearch({...search,template_message:e})}
                  />
              </div>   
            </div>

          

         
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmessageModal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Save'} onClick={() => sendTemplateMessage()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <DashboardMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Clients ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' />

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

              <DatePicker showTime={{ use12Hours: true, format: 'hh:mm A' }} size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

              <div className='mr-2 flex items-center mt-1 md:mt-0'>
                <input id="search_text" placeholder='Search Customer' type='text' value={search.text1} onChange={(e) => setsearch({ ...search, text1: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
                <div className='mx-2 w-[130px]'>
                <Select 
                  showSearch
                  filterOption={false}
                  value={search?.text == '' ? null : search?.text}
                  bordered={false}
                  // onSearch={searchemployee}
                  className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                  options={filterOption}
                  placeholder={<span className="text-[12px] text-gray-300 ">Select Standard</span>}
                  onChange={(e)=>setsearch({...search,text:filterOption.find((f)=>f?.value === e)})}
                  />
              </div>
              <div className='mr-2 w-[130px]'>
                <Select
                  showSearch
                  allowClear
                  filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  value={city === '' ? null : city}
                  bordered={false}
                  onChange={(v)=>{setcity(v || '');setpage(1)}}
                  className='border rounded h-[29px] border-slate-300 w-[100%]'
                  options={cityOptions}
                  placeholder={<span className="text-[12px] text-gray-300">Select City</span>}
                  />
              </div>
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              {selecteddataList?.length > 0 &&
              <div className='flex items-center'>
                {/* <div className='mr-2'>
                   <input id="search_text" placeholder='Add Template' type='text' value={search.template_message} onChange={(e) => setsearch({ ...search, template_message: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
                   <div className='w-[130px]'>
                    <Select 
                      showSearch
                      filterOption={false}
                      value={search?.template_message == '' ? null : search?.template_message}
                      className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
                      options={templateMessageArr}
                      placeholder={<span className="text-[12px] text-gray-300 ">Select Template</span>}
                      onChange={(e)=>setsearch({...search,template_message:e})}
                      />
                  </div>   
                </div> */}
                <div className='mt-1 mr-2 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Send Message" onClick={() => setmessageModal(true)} />
                </div>
                <div className='mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Send VoiceCall" onClick={() => setcallModal(!callModal)} />
                </div>
              </div>}
            </div>
          </div>



 <div className='flex mt-2 items-center border-t border-b overflow-x-auto flex-nowrap'>
                {sourceSystem?.map((s)=>(
                <h6 onClick={()=>{setselectedSourceSystem(s?.value);setselecteddataList([]);setpage(1)}} className={`font-[600] ${selectedSourceSystem === s?.value && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s?.label}</h6>
                ))}
            </div>
            <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {subscribedStatusSystem?.map((s)=>(
                <h6 onClick={()=>{setselectedsubscribedStatusSystem(s);setpage(1)}} className={`font-[600] ${selectedsubscribedStatusSystem === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>

          <div className='md:h-[80vh] mb-[50px] md:overflow-y-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}
            
          

           
            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                <div className='flex cursor-pointer items-center font-[600] mt-2'>
                  <h6 onClick={()=>selectOption('1')} className='text-[12px] mr-1 bg-slate-100 p-1'>Select All</h6>
                  <h6 onClick={()=>selectOption('2')} className='text-[12px] mr-1 bg-slate-100 p-1'>De Select All</h6>
                  <h6 onClick={()=>selectOption('3')} className='text-[12px] mr-1 bg-slate-100 p-1'>Remove All</h6>
                  {selecteddataList?.length > 0 && <h6 className='text-[11px]'>Data Selected ({selecteddataList?.length})</h6>}
                </div>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[80vh] mt-2 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Select</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Client Name</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Intested  / Subscribed</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[80px] w-[80px]  px-2 py-1 font-[600] text-slate-800 '>Actions</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
                       <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>
                        {selecteddataList?.includes(d?._id) ? <MdCheckBox size={20} onClick={()=>selectdatas(d?._id)} className='text-[#de9f19] cursor-pointer' /> : <MdCheckBoxOutlineBlank size={20} onClick={()=>selectdatas(d?._id)} className='text-slate-200 cursor-pointer' />}
                      </h6>

                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px] px-2 py-1 border-r'>
                        <span className='font-bold'>{d?.name}</span>
                        <br></br>
                        <span>Class : {d?.campaign_info?.enter_class}</span>
                        <h6>Handled By :</h6>
                        {d?.handled_by?.map((h)=>(<span className='font-bold text-blue-500'>{h?.name},</span>))}
                        {d?.session_status && <h6 className='text-[13px] w-max bg-green-200 text-green-900 p-1 text-[8px] font-[600]'>Session Active</h6>}

                        <h6 className='text-[11px]  font-[600] capitalize'>Source System :  {d?.source} </h6>
                        <div className='flex flex-wrap'>
                        {d?.app_installed && <h6 className='bg-green-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'App Installed'}</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Subscribed'}</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Temp Subscribed'}</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 p-[2px] m-[2px] text-[10px] font-[600] w-max rounded'>{'Demo Watched'}</h6>}
                        </div>
                      </h6>
                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.mobile}</span><br></br>
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       {d?.email}
                      </h6>
                      <h6 className=' text-[11px] break-word min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {d?.remarks}
                      </h6>
                      <h6 className='flex   break-word  min-w-[180px] w-[180px]  px-2 py-1 font-[500] border-r'>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />} <span className='mx-2 text-slate-300'>/</span>  {!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}  </h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LLL')}</h6>
                      <h6 className='flex items-start  min-w-[80px] w-[80px]  px-2 py-1 font-[500] '>
                        <AiOutlineEdit onClick={() => navigator('/dashboard/our_clients/edit', { state: d })} className='mr-2' />
                        <MdOutlineCallToAction onClick={() => navigator('/clients/list/call_to_customer', { state: d })} className='mr-2' />
                        {roles.includes('admin') && <AiOutlineDelete onClick={() => { setselecteddata(d); setmodal(true) }} />}
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-2 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div className='flex items-start'>
                          {selecteddataList?.includes(d?._id) ? <MdCheckBox size={20} onClick={()=>selectdatas(d?._id)} className='text-[#de9f19] cursor-pointer mr-2 mt-0.5 flex-shrink-0' /> : <MdCheckBoxOutlineBlank size={20} onClick={()=>selectdatas(d?._id)} className='text-slate-300 cursor-pointer mr-2 mt-0.5 flex-shrink-0' />}
                          <div>
                            <h6 className='text-[13px] font-[700]'>{d?.name}</h6>
                            <h6 className='text-[11px] text-slate-600'>{d?.mobile}</h6>
                          </div>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('/dashboard/our_clients/edit', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><MdOutlineCallToAction size={17} onClick={() => navigator('/clients/list/call_to_customer', { state: d })} /></span>
                          {roles.includes('admin') && <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => { setselecteddata(d); setmodal(true) }} /></span>}
                        </div>
                      </div>

                      <h6 className='text-[11px] mt-2'>Class : {d?.campaign_info?.enter_class || '-'}</h6>
                      <h6 className='text-[11px] font-[600] capitalize'>Source System : {d?.source}</h6>
                      {d?.email && <h6 className='text-[11px] break-all mt-1'>{d?.email}</h6>}
                      <h6 className='text-[11px] mt-1'>Handled By : {d?.handled_by?.map((h)=>h?.name).join(', ') || '-'}</h6>

                      <div className='flex flex-wrap gap-1 mt-1.5'>
                        {d?.session_status && <h6 className='text-[10px] bg-green-200 text-green-900 px-1.5 py-1 rounded font-[600]'>Session Active</h6>}
                        {d?.app_installed && <h6 className='bg-green-200 px-1.5 py-1 text-[10px] font-[600] rounded'>App Installed</h6>}
                        {d?.subscribed && <h6 className='bg-yellow-200 px-1.5 py-1 text-[10px] font-[600] rounded'>Subscribed</h6>}
                        {d?.temp_subscribed && <h6 className='bg-violet-200 px-1.5 py-1 text-[10px] font-[600] rounded'>Temp Subscribed</h6>}
                        {d?.demo_call_completed && <h6 className='bg-red-200 px-1.5 py-1 text-[10px] font-[600] rounded'>Demo Watched</h6>}
                      </div>

                      {d?.remarks && <h6 className='text-[11px] mt-2'><span className='font-[600]'>Remarks:</span> {d?.remarks}</h6>}

                      <div className='flex items-center mt-2 text-[11px]'>
                        <span className='font-[600] mr-1'>Interested</span>{!d?.interested ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                        <span className='mx-2 text-slate-300'>/</span>
                        <span className='font-[600] mr-1'>Subscribed</span>{!d?.subscribed ? <CgRadioCheck size={15} className='text-slate-300' /> : <CgRadioChecked size={15} className='text-yellow-500' />}
                      </div>

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LLL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default ReTargetClients